import * as types from '../../actions/vacancy-close/types';
import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';

const initialState = Immutable.fromJS({
  vacancyData: null,
  hiredApplications: null,
  activeApplicationsCount: null,
  areHiredApplicationsLoading: false,
  isActiveApplicationsCountLoading: false,
  isVacancyClosing: false,
  suggestedVacancy: null
});

export default reducerCreator(initialState, {
  [types.VACANCY_CLOSE_INITIATE]: (state, { schoolId, vacancyId }) => 
    state.set('vacancyData', { 
      schoolId: schoolId, 
      vacancyId: vacancyId
    }),

  [types.VACANCY_CLOSE_CANCEL]: (state) => 
    initialState,

  [types.VACANCY_CLOSE_SET_ACTIVE_APPLICATIONS_COUNT]: (state, { applicationsCount }) => 
    state.set('activeApplicationsCount', applicationsCount.availableResultsCount),

  [types.VACANCY_CLOSE_SET_HIRED_APPLICATIONS]: (state, { applications }) =>
    state.set('hiredApplications', applications),

  [types.VACANCY_CLOSE_SET_ACTIVE_APPLICATIONS_COUNT_LOADING]: (state, { isLoading }) =>
    state.set('isActiveApplicationsCountLoading', isLoading),

  [types.VACANCY_CLOSE_SET_HIRED_APPLICATIONS_LOADING]: (state, { isLoading }) => 
    state.set('areHiredApplicationsLoading', isLoading),

  [types.VACANCY_CLOSE_SET_CLOSING]: (state, { isClosing }) => 
    state.set('isVacancyClosing', isClosing),
  
  [types.VACANCY_CLOSE_SET_SUGGESTED_VACANCY]: (state, { schoolId, vacancyId }) =>
    state.set('suggestedVacancy', {
      schoolId: schoolId,
      vacancyId: vacancyId
    }),

  [types.VACANCY_CLOSE_RESET_SUGGESTED_VACANCY]: (state) =>
    state.set('suggestedVacancy', null)
});




// WEBPACK FOOTER //
// ./src/reducers/vacancies/vacancy-close.js